import React from 'react';

import Tag from '@amzn/meridian/tag';

import { ColumnState, ICellRendererParams } from 'ag-grid-community';
import { Link } from 'react-router-dom';
import { LINK_COLOR } from 'src/constants/agGrid';
import { ROUTES } from 'src/constants/routes';
import { emptyCellFormatter } from 'src/util/grid/cellFormatter';

export const vendorCodesColDefs = [
    {
        headerName: 'Vendor Name',
        field: 'entityName',
        filter: 'agSetColumnFilter',
        cellRenderer: (params: ICellRendererParams) => {
            return (
                <Link
                    style={{ color: LINK_COLOR, textDecoration: 'none' }}
                    to={`${ROUTES.VENDORS.INDEX}/${params.data.entityId}`}
                >
                    {params.value}
                </Link>
            );
        },
        comparator: (valueA: string, valueB: string) => {
            return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
        },
        width: 400,
        minWidth: 200
    },
    {
        headerName: 'Vendor Type',
        field: 'entityType',
        filter: 'agSetColumnFilter',
        minWidth: 100
    },
    {
        headerName: 'Catalog Code',
        field: 'catalogVendorCode',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        width: 250,
        minWidth: 200
    },
    {
        headerName: 'Royalty Code',
        field: 'royaltyVendorCode',
        filter: 'agSetColumnFilter',
        valueFormatter: emptyCellFormatter,
        width: 250,
        minWidth: 200
    },
    {
        headerName: 'Royalties Deal Status',
        field: 'dealStatus',
        filter: 'agSetColumnFilter',
        minWidth: 300,
        cellRenderer: (params: ICellRendererParams) => {
            const serviceList = params.value.split(', ');
            return (
                <>
                    {serviceList[0] === ''
                        ? '—'
                        : serviceList.map((service: string) => {
                              return (
                                  <>
                                      <Tag type="success" key={service}>
                                          {service}
                                      </Tag>
                                      <> </>
                                  </>
                              );
                          })}
                </>
            );
        }
    },
    {
        headerName: 'Vendor ID',
        field: 'entityId',
        filter: 'agSetColumnFilter',
        minWidth: 100
    }
];

export const vendorCodesColSortModel: ColumnState[] = [{ colId: 'entityName', sort: 'asc', sortIndex: 0 }];
